function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 6.001,
  cy: 6,
  r: 5.5,
  transform: "rotate(-180 6 6)",
  stroke: "#151619"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.5 8a.5.5 0 001 0h-1zm1-2.5a.5.5 0 00-1 0h1zm0 2.5V5.5h-1V8h1z",
  fill: "#151619"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 6.001,
  cy: 3.5,
  r: 0.5,
  fill: "#151619"
});

var SvgInfoIconBlack = function SvgInfoIconBlack(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgInfoIconBlack;